import { Component, Input } from '@angular/core';

@Component({
  selector: 'wave-component',
  templateUrl: './wave-component.component.html',
  styleUrl: './wave-component.component.scss'
})
export class WaveComponentComponent {
  @Input() isTyping = false;
}
